import React, { useState, useCallback, useEffect, useMemo } from "react";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { useDropzone } from "react-dropzone";
import Grid from "@material-ui/core/Grid";
import i18n from "../i18n";
import AuthService from "../session/AuthService";
import { withTranslation } from "react-i18next";

const baseStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#ff1744",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#ff1744",
  transition: "border .3s ease-in-out",
  cursor: "pointer"
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const Dropzone = (props) => {
  const [uploadedImage, setImage] = useState(null);
  const [name, setName] = useState("");

  const resizeImage = (file, width = 300, height = 300, callback) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            callback(blob);
          },
          file.type || "image/jpeg",
          1.0
        );
      };
    };
    reader.readAsDataURL(file);
  };

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      resizeImage(file, 400, 400, (resizedBlob) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImage(reader.result);
          setName(file.name);
          props.onUploadSuccess(new File([resizedBlob], file.name, { type: file.type }));
        });
        reader.readAsDataURL(resizedBlob);
      });
    }
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept: "image/jpeg, image/png",
    multiple: false,
    maxSize: 31457280 // 30 MB
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );
  const backtochooseimage = () => {
    setImage(null);
    setName("");
  };

  useEffect(() => {
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
  }, []);

  return (
    <div>
      <div {...getRootProps({ style })} className="card page-background text-center file-uploader">
        <input {...getInputProps()} />
        <div className="upload-icon">
          <CloudUploadIcon fontSize="inherit" />
        </div>
        <div className="text-large-weighted mb-3">
          {props.t("Drag and drop a file here or click to select a file")}
          <p>{props.t("Choose file below 30 mb else it will be auto removed from the list")}</p>
        </div>
      </div>

      {uploadedImage && (
        <>
        <div style={{ marginTop: "20px", }}>
          <img
            src={uploadedImage}
            alt={name}
            style={{ width: "100%", height: "auto", maxWidth: "100px", borderRadius:"100px",marginLeft:"220px" }} // Adjust maxWidth as needed
          />
        </div>
        <Grid container spacing={1} alignItems="center" wrap="nowrap">
          
              <button
                style={{ marginTop: "12px", marginBottom: "12px",marginLeft:"210px" }}
                onClick={backtochooseimage}
              >
                {props.t("Back")}
              </button>
         
          </Grid>
        </>
      )}
    </div>
  );
};

export default withTranslation()(Dropzone);